import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cmLSG from './_cmLSG';
import * as _cmSCL from './_cmSCL';

export const useGblz = (
  name: 
    'dsn' | // dimension
    'lcn' | // location
    'lgg' | // language
    'ctt' | // constant
    'scl' | // scale
    'user' | // user
    'stg' // setting
    , 
  itlz?: _ht.dz,
) => { // !!!!! global 変数が node に対応しているか確認要 !!!!!

  if (!(global as _ht.a).c) (global as _ht.a).c = {};
  if (!(global as _ht.a).c[name]) (global as _ht.a).c[name] = itlz?? {};

  const _clr = () => { // clear
    (global as _ht.a).c[name] = {};
  };

  const _set = (_dz: _ht.dz) => {
    _hm.udtDz((global as _ht.a).c[name], _dz);
  };

  const _get = () => {
    return (global as _ht.a).c[name];
  };

  const _rlc = (_dz: _ht.dz) => { // replace
    (global as _ht.a).c[name] = _dz;
  };

  const _rmvAsync = async () => {
    _clr();
    await _cmLSG.rmvAsync(name);
    return _get();
  };

  const _saveAsync = async (
    _dz: _ht.dz, 
    srt?: _ht.s
  ) => {
    _set(_dz);
    if (srt) _hm.l(`cmCPT warning: set srt`)
    await _cmLSG.setAsync(
      name, 
      (global as _ht.a).c[name],
      srt
    )
    return _get();
  };

  const _loadAsync = async (
    srt?: _ht.s
  ) => {
    if (srt) _hm.l(`cmCPT warning: set srt`)
    const _dz = await _cmLSG.getAsync(
      name, 
      srt
    );
    _set(_dz);
    return _get();
  };

  //_loadAsync();

//_hm.l(`gv 72: ${name}`);

  return {
    clr: _clr,
    rlc: _rlc,
    crt: (global as _ht.a).c[name],
    set: _set, // 既存項目は更新されないことに注意
    rmvAsync: _rmvAsync,
    saveAsync: _saveAsync,
    loadAsync: _loadAsync,
  }
};

export const useUserz = () => useGblz('user', {
  clrMode: 'l', // l: light, d: dark
  scl: 7, // scale
  ornDtm: '', // operation date time
  _10rz: { // ユーザ：履歴対象外
    _key: -1,
    _icn: 'blank domain id',
    _pfx: 'blank domain name',
  },
  _20rz: { // ドメイン：履歴対象外, _dmn は使用しない
    _key: -1,
    _icn: 'blank domain id',
    _pfx: 'blank domain name',
  },
});

export const useStgz = () => useGblz('stg', {
});

export const useDsnz = (_dz?: _ht.dz) => useGblz('dsn', _dz);
